import {
  NBS_API_GET_MY_PROFILE_REQUEST,
  NBS_API_GET_MY_PROFILE_SUCCESS,
  NBS_API_GET_MY_PROFILE_FAILURE,
  UPDATE_MY_PROFILE,
  RESET_MY_PROFILE
} from '../../constants/actions';

const initialState = {
  isFetching: null,
  error: null,
  timestamp: null,
  response: {},
  status: null
};

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case NBS_API_GET_MY_PROFILE_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: false,
        response: {},
        timestamp: new Date().toUTCString(),
        status: 'request'
      };
    case NBS_API_GET_MY_PROFILE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        response: action.response,
        timestamp: new Date().toUTCString(),
        status: 'success'
      };
    case NBS_API_GET_MY_PROFILE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        response: {},
        timestamp: new Date().toUTCString(),
        status: 'fail'
      };
    case UPDATE_MY_PROFILE:
      const { response } = state;
      const { data } = action;
      if (data.ext) {
        response.ext[data.key] = data.value;
      } else if (data.notifications) {
        response.notifications = action.data.notificationObject;
      } else if (data.location) {
        response.lat = data.location.lat;
        response.lon = data.location.lon;
      } else if (data.locationUpdated) {
        response.country = data.locationUpdated.country;
        response.state = data.locationUpdated.state;
        response.city = data.locationUpdated.city;
      } else {
        response[data.key] = data.value;
      }
      return {...state, response};
    case RESET_MY_PROFILE:
      return {...state, response: action.data};
    default:
      return state;
  }
}
